import { render, staticRenderFns } from "./floatingButton.vue?vue&type=template&id=639c0950&scoped=true"
import script from "./floatingButton.vue?vue&type=script&lang=js"
export * from "./floatingButton.vue?vue&type=script&lang=js"
import style0 from "./floatingButton.vue?vue&type=style&index=0&id=639c0950&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639c0950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('639c0950')) {
      api.createRecord('639c0950', component.options)
    } else {
      api.reload('639c0950', component.options)
    }
    module.hot.accept("./floatingButton.vue?vue&type=template&id=639c0950&scoped=true", function () {
      api.rerender('639c0950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/zdy_dragging/component/left/floatingButton.vue"
export default component.exports